import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TypesProposalProductBasicPlanState } from "./types-proposal-product-basic-plan-state";
import { RootState } from "../../../api/store";
import { SubTypeOption } from "../../../api/gms/group-category/group-category-api-state";


const initialState: TypesProposalProductBasicPlanState = {
    // proposal type (Customize/Prototype)
    selectedProposalType: null,
    // prototype
    selectedPrototypeType: null,
    // product
    selectedProductType: null,
    // basic plan
    selectedBasicPlans: null,
    // coverage type
    selectedCoverageType: null,
    csvFile: null,
    existingCsvFilePath: null,
};

const typesProposalProductBasicPlanSlice = createSlice({
    name: "typesProposalProductBasicPlanSlice",
    initialState,
    reducers: {
        // proposal type (Customize/Prototype)
        setSelectedProposalTypeBox: (state, action: PayloadAction<SubTypeOption | null>) => {
            state.selectedProposalType = action.payload;
        },
        // prototype
        setSelectedPrototypeTypeBox: (state, action: PayloadAction<SubTypeOption | null>) => {
            state.selectedPrototypeType = action.payload;
        },
        // product
        setSelectedProductTypeBox: (state, action: PayloadAction<SubTypeOption | null>) => {
            state.selectedProductType = action.payload;
        },
        // basic plan
        setSelectedBasicPlansBox: (state, action: PayloadAction<SubTypeOption | null>) => {
            state.selectedBasicPlans = action.payload;
        },
        // coverage type
        setSelectedCoverageTypeBox: (state, action: PayloadAction<SubTypeOption | null>) => {
            state.selectedCoverageType = action.payload;
        },
        setCsvFile: (state, action: PayloadAction<File | null>) => {
            state.csvFile = action.payload;
        },
        resetCsvFile: (state) => {
            state.csvFile = null
        },
        setExistingCsvFilePath: (state, action: PayloadAction<string | null>) => {
            state.existingCsvFilePath = action.payload;
        },
        resetCoverageType: (state) => {
            state.selectedCoverageType = null
            state.csvFile = null
            state.existingCsvFilePath = null
        },
    },
});

export const { 
    // proposal type (Customize/Prototype)
    setSelectedProposalTypeBox,
    // prototype
    setSelectedPrototypeTypeBox,
    // Product
    setSelectedProductTypeBox,
    // Basic Plan
    setSelectedBasicPlansBox,
    // coverage type
    setSelectedCoverageTypeBox,
    setCsvFile,
    resetCsvFile,
    setExistingCsvFilePath,
    resetCoverageType
} = typesProposalProductBasicPlanSlice.actions;

// Proposal type (Customize/Prototype)
export const selectProposalTypeState = (state: RootState) => state.typesProposalProductBasicPlanSlice.selectedProposalType;
// Prototype
export const selectPrototypeTypeState = (state: RootState) => state.typesProposalProductBasicPlanSlice.selectedPrototypeType;
// Product
export const selectProductTypeState = (state: RootState) => state.typesProposalProductBasicPlanSlice.selectedProductType;
// Basic Plan
export const selectBasicPlansState = (state: RootState) => state.typesProposalProductBasicPlanSlice.selectedBasicPlans;
// Coverage Type
export const selectCoverageTypeState = (state: RootState) => state.typesProposalProductBasicPlanSlice.selectedCoverageType;
export const selectExistingCsvFilePath = (state: RootState) => state.typesProposalProductBasicPlanSlice.existingCsvFilePath;
export const selectCSVFile = (state: RootState) => state.typesProposalProductBasicPlanSlice.csvFile;

export default typesProposalProductBasicPlanSlice.reducer;
